import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import { createCollaborationSidebarStateFollower } from '../store/collaborationSidebarState';
import { useStore } from 'collaboration-sidebar-common/store/store';
import { getInitialCollaborationSidebarState } from '../utils';
const initialCollaborationSidebarState = getInitialCollaborationSidebarState();

/**
 * Hook for components that need to follow the collaboration sidebar state
 * without being within the provider hierarchy.
 *
 * Creates a follower store per component instance that syncs with the leader via Magpie.
 * Use this for components like CommentableArea that may be rendered outside
 * the main CollaborationSidebarProvider tree.
 */
export const useCollaborationSidebarStateFollower = () => {
  "use memo";

  const $ = _c(6);
  const [follower] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== follower) {
    t0 = () => () => {
      follower.cleanup();
    };
    t1 = [follower];
    $[0] = follower;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const collaborationSidebarState = useStore(follower, _temp2);
  let t2;
  if ($[3] !== collaborationSidebarState || $[4] !== follower.actions.onUpdateCollaborationSidebarState) {
    t2 = {
      collaborationSidebarState,
      onUpdateCollaborationSidebarState: follower.actions.onUpdateCollaborationSidebarState
    };
    $[3] = collaborationSidebarState;
    $[4] = follower.actions.onUpdateCollaborationSidebarState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useCollaborationSidebarStateFollower;
function _temp() {
  return createCollaborationSidebarStateFollower();
}
function _temp2(value) {
  return value !== null && value !== void 0 ? value : initialCollaborationSidebarState;
}